import dayjs from 'dayjs';

export const getDonationTime = (donationDate: string) => {
  const today = dayjs();
  const dateDiff = today.diff(donationDate, 'minute');
  if (dateDiff < 60) {
    return `${dateDiff} min`;
  }
  if (dateDiff < 60 * 24) {
    return `${today.diff(donationDate, 'hour')} hr`;
  }
  return `${today.diff(donationDate, 'day')} d`;
};
